import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
/**
 * Shared plan rendering component used by both AgentPanel (workspace chat)
 * and ProjectMessageView (project chat) for display parity.
 * Uses glassmorphic design: dark glass background, green accents.
 */
export const PlanView = React.memo(function PlanView({ plan }) {
    return (_jsxs("div", { style: {
            margin: '8px 0',
            padding: 12,
            borderRadius: 10,
            border: '1px solid rgba(34, 197, 94, 0.12)',
            backgroundColor: 'var(--sam-glass-bg-surface)',
        }, children: [_jsx("h4", { style: { fontSize: '0.75rem', fontWeight: 500, color: 'var(--sam-color-fg-muted)', textTransform: 'uppercase', marginBottom: 8, marginTop: 0 }, children: "Plan" }), _jsx("ul", { style: { listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 4 }, children: plan.entries.map((entry, idx) => (_jsxs("li", { style: { display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.875rem' }, children: [_jsx("span", { style: {
                                display: 'inline-block',
                                height: 8,
                                width: 8,
                                borderRadius: '50%',
                                flexShrink: 0,
                                backgroundColor: entry.status === 'completed' ? '#22c55e' :
                                    entry.status === 'in_progress' ? '#22c55e' : '#4a6a60',
                                boxShadow: entry.status === 'in_progress' ? '0 0 6px rgba(34, 197, 94, 0.5)' : 'none',
                                animation: entry.status === 'in_progress' ? 'glowPulse 2s ease-in-out infinite' : 'none',
                            } }), _jsx("span", { style: {
                                color: entry.status === 'completed' ? 'var(--sam-color-fg-muted)' : 'var(--sam-color-fg-primary)',
                                textDecoration: entry.status === 'completed' ? 'line-through' : 'none',
                                opacity: entry.status === 'completed' ? 0.7 : 1,
                            }, children: entry.content })] }, idx))) })] }));
});
//# sourceMappingURL=PlanView.js.map